export const DISPATCH_CONFIG = {
  init: { action: null, comment: null, commentType: null, openForm: null, isTextareaFocused: null },
  createInternal: { action: 'create', comment: {}, commentType: 'internal', openForm: true, isTextareaFocused: true },
  createPublic: { action: 'create', comment: {}, commentType: 'public', openForm: true, isTextareaFocused: true },
  edit: { action: 'edit', openForm: true, isTextareaFocused: true },
  forward: { action: 'forward', openForm: true, isTextareaFocused: false },
  delete: { action: 'delete', openForm: false, isTextareaFocused: false },
};
